<mat-form-field appearance="outline" [formGroup]="formulario" [ngClass]="classe">
  <mat-label>{{descricao}}</mat-label>
  <input class="text-left"
    matInput
    [type]="tipo"
    [attr.inputmode]="modoInsercao"
    [disabled]="disabled"
    [formControlName]="nomeControle"
    [autocomplete]="autoPreenchimento"
    [id]="identificacao"
    (change)="change()"
    currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
    />

    <app-botao *ngIf="botaoAcao"
      matSuffix
      icone="fas fa-search"
      (clique)="change()"
      ></app-botao>
  <mat-hint>{{textoAjuda}}</mat-hint>
</mat-form-field>
